import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/Login.vue";
import Landing from "@/views/public/Landing.vue";
import Signup from "@/views/public/Signup.vue";
import VerifyAccount from "@/views/public/VerifyAccount.vue";
import RecoverPassword from "@/views/public/RecoverPassword.vue";
import Dashboard from "@/views/boarua/Dashboard.vue";
import ResourceList from "@/views/boarua/ResourceList.vue";
import AssociationAdmins from "@/views/boarua/AssociationAdmins.vue";
import ContributionGroups from "@/views/boarua/ContributionGroups.vue";
import PaymentSettings from "@/views/boarua/PaymentSettings.vue";
import PayoutTransfers from "@/views/boarua/PayoutTransfers.vue";
import FinancialCashFlow from "@/views/boarua/FinancialCashFlow.vue";
import FinancialStatements from "@/views/boarua/FinancialStatements.vue";
import VisualSettings from "@/views/boarua/VisualSettings.vue";
import SecurityCenter from "@/views/boarua/SecurityCenter.vue";
import GatehouseCenter from "@/views/boarua/GatehouseCenter.vue";
import SupportTickets from "@/views/boarua/SupportTickets.vue";
import ValueModules from "@/views/boarua/ValueModules.vue";
import AcceptAdminInvite from "@/views/public/AcceptAdminInvite.vue";

const guard = function (to: any, from: any, next: any) {
  const token = localStorage.getItem("token");

  if (!token && to.path !== "/login") {
    next({ path: "/login" });
    return;
  }

  next();
};

Vue.use(VueRouter);

const listHeaders = {
  invites: [
    { text: "ID", value: "id", width: 80 },
    { text: "Celular", value: "phone" },
    { text: "Perfil", value: "role" },
    { text: "Status", value: "status", sortable: false },
    { text: "Criado em", value: "created_at" },
  ],
  demands: [
    { text: "ID", value: "id", width: 80 },
    { text: "Titulo", value: "title" },
    { text: "Categoria", value: "category" },
    { text: "Prioridade", value: "priority" },
    { text: "Status", value: "status" },
    { text: "Apoios", value: "support_count", width: 110 },
    { text: "Criado em", value: "created_at", width: 150 },
  ],
  charges: [
    { text: "ID", value: "id", width: 80 },
    { text: "Referencia", value: "reference_month" },
    { text: "Residência", value: "unit_label" },
    { text: "Pagador", value: "payer_label" },
    { text: "Núcleo", value: "group_label" },
    { text: "Escopo", value: "charge_scope" },
    { text: "Origem", value: "payment_origin" },
    { text: "Valor", value: "amount" },
    { text: "Vencimento", value: "due_date" },
    { text: "Status", value: "status" },
  ],
  financialAccounts: [
    { text: "Nome", value: "name" },
    { text: "Tipo", value: "type" },
    { text: "Saldo inicial", value: "opening_balance" },
    { text: "Data do saldo", value: "opening_balance_date" },
    { text: "Status", value: "status" },
    { text: "", value: "actions", align: "end", sortable: false },
  ],
  assemblies: [
    { text: "ID", value: "id", width: 80 },
    { text: "Titulo", value: "title" },
    { text: "Data", value: "starts_at" },
    { text: "Local", value: "location_name" },
    { text: "Status", value: "status" },
  ],
  feed: [
    { text: "ID", value: "id", width: 80 },
    { text: "Titulo", value: "title" },
    { text: "Status", value: "status" },
    { text: "Publicado em", value: "published_at" },
  ],
};

const commonFilters = {
  statuses: [
    { text: "Ativo", value: "active" },
    { text: "Inativo", value: "inactive" },
    { text: "Pendente", value: "pending" },
    { text: "Pago", value: "paid" },
    { text: "Vencido", value: "overdue" },
    { text: "Aberto", value: "open" },
    { text: "Fechado", value: "closed" },
    { text: "Publicado", value: "published" },
    { text: "Rascunho", value: "draft" },
    { text: "Agendada", value: "scheduled" },
    { text: "Em andamento", value: "in_progress" },
    { text: "Concluída", value: "completed" },
    { text: "Cancelada", value: "cancelled" },
  ],
  demandStatuses: [
    { text: "Aberto", value: "open" },
    { text: "Em análise", value: "in_review" },
    { text: "Em andamento", value: "in_progress" },
    { text: "Aguardando morador", value: "waiting_resident" },
    { text: "Resolvido", value: "resolved" },
    { text: "Fechado", value: "closed" },
    { text: "Cancelado", value: "cancelled" },
  ],
  demandPriorities: [
    { text: "Baixa", value: "low" },
    { text: "Normal", value: "normal" },
    { text: "Média", value: "medium" },
    { text: "Alta", value: "high" },
    { text: "Urgente", value: "urgent" },
  ],
  demandCategories: [
    { text: "Financeiro", value: "financial" },
    { text: "Manutenção", value: "maintenance" },
    { text: "Segurança", value: "security" },
    { text: "Limpeza", value: "cleaning" },
    { text: "Iluminação", value: "lighting" },
    { text: "Administrativo", value: "administrative" },
    { text: "Outro", value: "other" },
  ],
};

const routes = [
  {
    path: "/",
    component: () => import("@/layouts/Public.vue"),
    children: [
      { path: "/", name: "Landing", component: Landing },
      { path: "/criar-conta", name: "Signup", component: Signup },
      { path: "/verificar-conta", name: "VerifyAccount", component: VerifyAccount },
      { path: "/recuperar-senha", name: "RecoverPassword", component: RecoverPassword },
      { path: "/aceitar-admin", name: "AcceptAdminInvite", component: AcceptAdminInvite },
      { path: "/login", name: "login", component: Login },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/Private.vue"),
    beforeEnter: guard,
    children: [
      { path: "/home", name: "Home", component: Dashboard, beforeEnter: guard },
      { path: "/associacoes", redirect: "/home", beforeEnter: guard },
      {
        path: "/convites",
        redirect: "/operacao/residencias",
        beforeEnter: guard,
      },
      {
        path: "/demandas",
        name: "Demands",
        component: ResourceList,
        beforeEnter: guard,
        meta: {
          title: "Chamados",
          subtitle: "Solicitações de moradores para a gestão local",
          endpoint: "/demands",
          headers: listHeaders.demands,
          filterDateKeys: ["created_at", "updated_at"],
          filterFields: [
            { name: "status", label: "Status", type: "select", items: commonFilters.demandStatuses },
            { name: "priority", label: "Prioridade", type: "select", items: commonFilters.demandPriorities },
            { name: "category", label: "Categoria", type: "select", items: commonFilters.demandCategories },
          ],
          updateFields: ["status", "priority"],
          canCreate: false,
          editTitle: "Gerenciar chamado",
          formIntro: "Visualize o relato recebido e atualize a triagem operacional.",
          formFields: [
            { type: "section", label: "Detalhes do chamado", text: "Informações enviadas pelo morador." },
            { name: "title", label: "Título", readonly: true, cols: 8 },
            { name: "category", label: "Categoria", type: "select", items: commonFilters.demandCategories, readonly: true, cols: 4 },
            { name: "description", label: "Descrição", type: "textarea", readonly: true, cols: 12 },
            { name: "resident_name", path: "member.user.name", label: "Morador", readonly: true, cols: 6 },
            { name: "unit_label", path: "unitLabel", label: "Residência", readonly: true, cols: 6 },
            { name: "location_label", path: "locationLabel", label: "Local informado", readonly: true, cols: 12 },
            { type: "section", label: "Gestão do atendimento", text: "Defina prioridade e acompanhe o status do chamado." },
            { name: "priority", label: "Prioridade", type: "select", items: commonFilters.demandPriorities, cols: 6 },
            { name: "status", label: "Status", type: "select", items: commonFilters.demandStatuses, cols: 6 },
            { name: "support_count", label: "Apoios de moradores", readonly: true, cols: 6 },
            { name: "created_at_label", path: "createdAtLabel", label: "Criado em", readonly: true, cols: 6 },
          ],
        },
      },
      {
        path: "/nucleos",
        name: "ContributionGroups",
        component: ContributionGroups,
        beforeEnter: guard,
        meta: { title: "Núcleos", subtitle: "Ruas, condomínios e comércios" },
      },
      {
        path: "/financeiro",
        name: "MonthlyCharges",
        component: ResourceList,
        beforeEnter: guard,
        meta: {
          title: "Financeiro",
          subtitle: "Mensalidades e boletos",
          endpoint: "/monthly-charges",
          headers: listHeaders.charges,
          filterDateKeys: ["due_date", "created_at", "updated_at"],
          filterFields: [
            { name: "status", label: "Status", type: "select", items: commonFilters.statuses },
            { name: "reference_month", label: "Referência" },
          ],
        },
      },
      {
        path: "/financeiro/repasses",
        name: "PayoutTransfers",
        component: PayoutTransfers,
        beforeEnter: guard,
        meta: { title: "Financeiro", subtitle: "Repasses do local" },
      },
      {
        path: "/financeiro/contas",
        name: "FinancialAccounts",
        component: ResourceList,
        beforeEnter: guard,
        meta: {
          title: "Contas financeiras",
          subtitle: "Contas internas usadas para importar extratos, conciliar movimentações e projetar saldos.",
          endpoint: "/financial/accounts",
          headers: listHeaders.financialAccounts,
          filterDateKeys: ["created_at", "updated_at"],
          filterFields: [
            { name: "status", label: "Status", type: "select", items: commonFilters.statuses },
            {
              name: "type",
              label: "Tipo",
              type: "select",
              items: [
                { text: "Conta corrente", value: "checking" },
                { text: "Caixa", value: "cash" },
                { text: "Poupança", value: "savings" },
                { text: "Reserva", value: "reserve" },
                { text: "Outro", value: "other" },
              ],
            },
          ],
          createButtonLabel: "Adicionar",
          createTitle: "Nova conta financeira",
          editTitle: "Editar conta financeira",
          formIntro: "Cadastre uma conta interna para organizar extratos e movimentações.",
          formFields: [
            { name: "name", label: "Nome", cols: 8 },
            {
              name: "type",
              label: "Tipo",
              type: "select",
              cols: 4,
              default: "checking",
              items: [
                { text: "Conta corrente", value: "checking" },
                { text: "Caixa", value: "cash" },
                { text: "Poupança", value: "savings" },
                { text: "Reserva", value: "reserve" },
                { text: "Outro", value: "other" },
              ],
            },
            { name: "opening_balance", label: "Saldo inicial", type: "currency", cols: 6, default: 0 },
            { name: "opening_balance_date", label: "Data do saldo", type: "date", cols: 6 },
            { name: "status", label: "Status", type: "select", cols: 12, default: "active", items: commonFilters.statuses },
          ],
        },
      },
      {
        path: "/financeiro/fluxo-de-caixa",
        name: "FinancialCashFlow",
        component: FinancialCashFlow,
        beforeEnter: guard,
        meta: { title: "Financeiro", subtitle: "Fluxo de caixa" },
      },
      {
        path: "/financeiro/extratos",
        name: "FinancialStatements",
        component: FinancialStatements,
        beforeEnter: guard,
        meta: { title: "Financeiro", subtitle: "Importação e conciliação de extratos" },
      },
      {
        path: "/financeiro/prestacao",
        name: "FinancialAccountability",
        component: ValueModules,
        beforeEnter: guard,
        meta: { title: "Financeiro", subtitle: "Prestação de contas", module: "prestacao" },
      },
      {
        path: "/pagamentos",
        redirect: "/configuracoes/pagamentos",
        beforeEnter: guard,
      },
      {
        path: "/configuracoes",
        redirect: "/configuracoes/pagamentos",
        beforeEnter: guard,
      },
      {
        path: "/configuracoes/pagamentos",
        name: "PaymentSettings",
        component: PaymentSettings,
        beforeEnter: guard,
        meta: { title: "Configurações", subtitle: "Pagamentos do local" },
      },
      {
        path: "/configuracoes/conta",
        name: "AccountSettings",
        component: PaymentSettings,
        beforeEnter: guard,
        meta: { title: "Configurações", subtitle: "Conta BOARUA" },
      },
      {
        path: "/configuracoes/planos",
        name: "PlanSettings",
        component: PaymentSettings,
        beforeEnter: guard,
        meta: { title: "Configurações", subtitle: "Planos BOARUA" },
      },
      {
        path: "/configuracoes/visual",
        name: "VisualSettings",
        component: VisualSettings,
        beforeEnter: guard,
        meta: { title: "Configurações", subtitle: "Identidade visual do local" },
      },
      {
        path: "/administradores",
        name: "AssociationAdmins",
        component: AssociationAdmins,
        beforeEnter: guard,
        meta: { title: "Administradores", subtitle: "Acessos administrativos do local" },
      },
      {
        path: "/operacao",
        redirect: "/operacao/residencias",
        beforeEnter: guard,
      },
      {
        path: "/operacao/prestacao",
        redirect: "/financeiro/prestacao",
        beforeEnter: guard,
      },
      {
        path: "/operacao/:module",
        name: "ValueModules",
        component: ValueModules,
        beforeEnter: guard,
        meta: { title: "Operação", subtitle: "Recursos para gestão do local" },
      },
      {
        path: "/seguranca",
        redirect: "/seguranca/central",
        beforeEnter: guard,
      },
      {
        path: "/seguranca/:section",
        name: "SecurityCenter",
        component: SecurityCenter,
        beforeEnter: guard,
        meta: { title: "Segurança", subtitle: "Central de alertas e equipes operacionais" },
      },
      {
        path: "/portaria",
        redirect: "/portaria/autorizacoes",
        beforeEnter: guard,
      },
      {
        path: "/portaria/:section",
        name: "GatehouseCenter",
        component: GatehouseCenter,
        beforeEnter: guard,
        meta: { title: "Portaria", subtitle: "Autorizações, entradas e operadores" },
      },
      {
        path: "/suporte",
        name: "SupportTickets",
        component: SupportTickets,
        beforeEnter: guard,
        meta: { title: "Suporte", subtitle: "Tickets com a equipe BOARUA" },
      },
      {
        path: "/assembleias",
        name: "Assemblies",
        component: ResourceList,
        beforeEnter: guard,
        meta: {
          title: "Assembleias",
          subtitle: "Agenda, locais e assinaturas",
          endpoint: "/assemblies",
          headers: listHeaders.assemblies,
          filterDateKeys: ["starts_at", "ends_at", "created_at"],
          filterFields: [{ name: "status", label: "Status", type: "select", items: commonFilters.statuses }],
          createButtonLabel: "Adicionar",
          createTitle: "Nova assembleia",
          editTitle: "Editar assembleia",
          formFields: [
            { name: "title", label: "Título", cols: 8 },
            {
              name: "status",
              label: "Status",
              type: "select",
              cols: 4,
              default: "scheduled",
              items: [
                { text: "Agendada", value: "scheduled" },
                { text: "Em andamento", value: "in_progress" },
                { text: "Concluída", value: "completed" },
                { text: "Cancelada", value: "cancelled" },
              ],
            },
            { name: "starts_at", label: "Data e hora de início", type: "datetime-local", cols: 6 },
            { name: "ends_at", label: "Data e hora de término", type: "datetime-local", cols: 6 },
            { name: "location_name", label: "Local", cols: 6 },
            { name: "location_address", label: "Endereço", cols: 6 },
            { name: "description", label: "Descrição/pauta", type: "textarea", cols: 12 },
          ],
        },
      },
      {
        path: "/feed",
        name: "FeedPosts",
        component: ResourceList,
        beforeEnter: guard,
        meta: {
          title: "Feed",
          subtitle: "Publicações do local",
          endpoint: "/feed-posts",
          headers: listHeaders.feed,
          fixedPostTypes: ["announcement", "improvement", "work", "accountability"],
          filterDateKeys: ["published_at", "created_at", "updated_at"],
          filterFields: [{ name: "status", label: "Status", type: "select", items: commonFilters.statuses }],
          createButtonLabel: "Adicionar",
          createTitle: "Nova publicação",
          editTitle: "Editar publicação",
          formIntro: "Atualize o conteúdo que será exibido no feed do local.",
          formFields: [
            { name: "title", label: "Título", cols: 8 },
            {
              name: "post_type",
              label: "Tipo",
              type: "select",
              cols: 4,
              default: "announcement",
              items: [
                { text: "Comunicado", value: "announcement" },
                { text: "Melhoria", value: "improvement" },
                { text: "Obra", value: "work" },
                { text: "Prestação de contas", value: "accountability" },
              ],
            },
            {
              name: "status",
              label: "Status",
              type: "select",
              cols: 6,
              default: "published",
              items: [
                { text: "Publicado", value: "published" },
                { text: "Rascunho", value: "draft" },
              ],
            },
            { name: "published_at", label: "Publicado em", type: "datetime-local", cols: 6 },
            { name: "content", label: "Conteúdo", type: "textarea", cols: 12 },
          ],
        },
      },
    ],
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
